<!--
 * @Author: Soul
 * @Date: 2021-06-25 17:23:14
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2022-09-29 15:24:31
 * @Description: file content
-->
<template>
  <div class="bg">
    <!-- 右侧导航 -->
    <BaseImg :option="{
      style: {
        margin: '20px auto 0',
        width: '341px',
      },
      url: $projectId == '2601' ? 'logo4.png' : $projectId == '2605' ? 'logo7.png' : 'logo.png',
    }"/>
    <BaseImg :option="{
      style: {
        margin: '29px auto 0',
        width: '322px'
      },
      url: $projectId == '2597' ? 'slogan1.png' : $projectId == '2604' ? 'slogan2.png' : $projectId == '2601' ? 'slogan4.png' : $projectId == '2605' ? 'slogan7.png' : $projectId == '2600' ? 'slogan5.png' : $projectId == '2598' ? 'slogan6.png' : 'slogan.png'
    }"/>
    <div class="answer-box">
      <img :src="`${imgHost}answer_title.png?v=${$config.OSSVersion}`" />
      <div class="icon act_animate_shake_seesaw_config" @click="$goPage(`coupon?proejctId=${$projectId}`)"></div>
      <div class="asnwer_txt">1.您的姓名：</div>
      <div class="input_txt">
        <input @blur="blurInput" v-model="name" type="text" placeholder="请输入您的姓名" />
      </div>
      <div class="asnwer_txt">2.您的电话：</div>
      <div class="input_txt">
        <input @blur="blurInput" v-model="mobile" type="tel" placeholder="请输入您的手机号码" />
      </div>
      <div class="input_txt">
        <div class="left">
          <input @blur="blurInput" v-model="vcode" type="number" placeholder="输入验证码" oninput="if(value.length>6)value=value.slice(0,6)" />
        </div>
        <div class="right">
          <div @click="getVcode" v-if="!showVcode">{{getVcodes}}</div>
          <div v-else>{{counts}}s</div>
        </div>
      </div>
      <div class="asnwer_txt" v-if="questionList[2]">3.{{questionList[2].name}}:</div>
      <div class="asnwer_radio">
        <div class="radio" :class="{choose: isBuy == 1}" @click="chooseIsBuy(1)">是</div>
        <div class="radio" :class="{choose: isBuy == 2}" @click="chooseIsBuy(2)">否</div>
      </div>
      <div class="btn" :class="{not: !canGet}" v-if="showBtn" @click="submit"></div>
    </div>
    <div class="code-box">
      <img :src="qrCode" />
      <div class="txt"></div>
    </div>
    <div class="mask" v-show="showMask">
      <div class="answer-box1">
        <div class="asnwer_txt" v-if="questionList[3]">1.{{questionList[3].name}}</div>
        <div class="asnwer_radio" v-if="questionList[3]">
          <div class="radio" :class="{choose: item.choose}" v-for="(item, index) in questionList[3].options" :key="'5' + index" @click="handleAnswer(3, index)">{{item.name}}</div>
        </div>
        <div class="asnwer_txt" v-if="questionList[4]">2.{{questionList[4].name}}</div>
        <div class="asnwer_radio" v-if="questionList[4]">
          <div class="radio" :class="{choose: item.choose}" v-for="(item, index) in questionList[4].options" :key="'6' + index" @click="handleAnswer(4, index)">{{item.name}}</div>
        </div>
        <div class="asnwer_txt" v-if="questionList[5]">3.{{questionList[5].name}}</div>
        <div class="asnwer_radio" v-if="questionList[5]">
          <div class="radio" :class="{choose: item.choose}" v-for="(item, index) in questionList[5].options" :key="'7' + index" @click="handleAnswer(5, index)">{{item.name}}</div>
        </div>
        <div class="btn-box" @click="submit1">
          <div class="btn" :class="{not: !canGet}"></div>
        </div>
      </div>
    </div>
    <div class="mask" v-show="showRedPac">
      <div class="redPac-box">
        <div class="box">
          <div class="before" v-if="redPacStatus == 1">
            <div class="top" :class="{ top1: $projectId == '2623', ani: showRedPacAni1 }"></div>
            <div class="btn" :class="{ ani: showRedPacAni }" @click="getRedPac" v-if="!showRedPacAni1"></div>
          </div>
          <div class="result" v-if="redPacMoney > 0">
            <div class="txt">恭喜您获得</div>
            <div class="money">{{redPacMoney}}<span>元</span></div>
            <div class="tips">已发放至微信零钱，预计5分钟内到账<br />请您注意查看微信列表提示</div>
            <div class="btn" v-if="redPacStatus != 1" @click="$goPage(`coupon?proejctId=${$projectId}`)">确认领取</div>
          </div>
          <div class="result" v-else>
            <div class="txt1">很抱歉~<br />红包已经领完啦</div>
            <div class="btn" v-if="redPacStatus != 1" @click="$goPage(`coupon?proejctId=${$projectId}`)">确认</div>
          </div>
        </div>
      </div>
    </div>
    <div class="img-loading">
      <img :src="`${imgHost}redpac_btn1.png?v=${$config.OSSVersion}`" />
      <img :src="`${imgHost}redpac_btn2.png?v=${$config.OSSVersion}`" />
      <img :src="`${imgHost}redpac_top1.png?v=${$config.OSSVersion}`" />
      <img :src="`${imgHost}redpac_top2.png?v=${$config.OSSVersion}`" />
      <img :src="`${imgHost}redpac_bottom.png?v=${$config.OSSVersion}`" />
    </div>
  </div>
</template>

<script>
import { MessageBox, Toast, Indicator } from "mint-ui";
import Vue from "vue/dist/vue.js";
import FingerprintJS from '@fingerprintjs/fingerprintjs'
export default {
  components: {
  },
  data() {
    return {
      projectIndex: 0,
      projectList: [
        {
          name: '金地江山风华',
          projectId: 2597,
          boxIndex: 1,
        },
        {
          name: '金地樾檀山',
          projectId: 2604,
          boxIndex: 1,
        },
        {
          name: '金地时代风华',
          projectId: 2602,
          boxIndex: 2,
        },
        {
          name: '金地棕榈岛',
          projectId: 2601,
          boxIndex: 2,
        },
        {
          name: '金地浅山艺境',
          projectId: 2600,
          boxIndex: 3,
        },
        {
          name: '金地九韵风华',
          projectId: 2598,
          boxIndex: 2,
        },
        {
          name: '金地峯范',
          projectId: 2599,
          boxIndex: 1,
        },
        {
          name: '金地名京',
          projectId: 2605,
          boxIndex: 2,
        },
        {
          name: '金地朗悦',
          projectId: 2603,
          boxIndex: 2,
        },
      ],
      vcode: "",
      name: "",
      mobile: "",
      counts: "",
      timers: null,
      getVcodes: "获取验证码",
      showVcode: false,
      isBuy: 0,
      showMask: false,
      questionList: [],
      submitList: [],
      submitList1: [],
      canGet: false,
      showBtn: false,
      surveyId: 0,
      qrCode: null,
      showRedPac: false,
      redPacStatus: 1,
      showRedPacAni: false,
      showRedPacAni1: false,
      redPacMoney: 0
    };
  },
  filters: {
    formatTime: function (value) {
      return value < 10 ? "0" + value : value;
    }
  },
  watch: {},
  computed:{
  },
  methods: {
    getRedPac() {
      if (this.showRedPacAni || this.showRedPacAni1) {
        return
      }
      this.showRedPacAni = true
      setTimeout(()=> {
        this.showRedPacAni1 = true
        setTimeout(()=> {
          this.redPacStatus = 2
        }, 1000)
      }, 1000)
    },
    async chooseIsBuy(num) {
      if (!this.name) {
        return MessageBox.alert("请先输入姓名", "提示");
      } else if (!this.mobile) {
        return MessageBox.alert("请先输入手机号", "提示");
      } else {
        if (!this.$util.isMobile(this.mobile)) {
          return MessageBox.alert("请填写正确的手机号", "提示");
        }
      }
      if (!this.vcode) {
        return MessageBox.alert("请先输入验证码", "提示");
      }
      this.isBuy = num
      if (this.isBuy === 1) {
        this.showBtn = true
      } else {
        this.showBtn = false
        this.showMask = true
      }
    },
    handleAnswer(num, index) {
      if (num != 4) {
        this.$set(this.questionList[num].options[index], 'choose', !this.questionList[num].options[index].choose)
      } else {
        this.questionList[num].options.forEach((v, i) => {
          this.$set(this.questionList[num].options[i], 'choose', false)
        })
        this.$set(this.questionList[num].options[index], 'choose', true)
      }
    },
    async submit() {
      if (!this.name) {
        return MessageBox.alert("请先输入姓名", "提示");
      } else if (!this.mobile) {
        return MessageBox.alert("请先输入手机号", "提示");
      } else {
        if (!this.$util.isMobile(this.mobile)) {
          return MessageBox.alert("请填写正确的手机号", "提示");
        }
      }
      if (!this.vcode) {
        return MessageBox.alert("请先输入验证码", "提示");
      }
      let data = await this.$httpdf.get(this.apiHost + `user/saveMobile`, {
        mobile: this.mobile,
        verCode: this.vcode
      })
      if (data.code === 0) {
        Vue.prototype.$mobile = this.mobile
        this.$util.cookie.set("mobile", this.$mobile, {
          expires: 60,
        });
        this.submitList.push({
          questionId: this.questionList[0].questionId,
          options: [{
            id: this.questionList[0].options[0].id,
            text: this.name
          }]
        })
        this.submitList.push({
          questionId: this.questionList[1].questionId,
          options: [{
            id: this.questionList[1].options[0].id,
            text: this.mobile
          }]
        })
        this.submitList.push({
          questionId: this.questionList[2].questionId,
          options: [{
            id: this.questionList[2].options[0].id,
            text: this.questionList[2].options[0].name,
          }]
        })
        data = await this.$httpdf.post( this.apiHost + 'jdQuestion/' + this.surveyId + '/submit', { answers: this.submitList })
        if (data.code === 0) {
          if (this.canGet) {
            let parm = new FormData();
            parm.append("name", this.$userInfo.nickName);
            data = await this.$httpdf.post( this.apiHost + 'jdQuestion/receive', parm)
            this.showRedPac = true
            if (data.code == 0) {
              this.redPacMoney = data.data
            } else {
              this.redPacMoney = 0
            }
          } else {
            this.$goPage(`coupon?proejctId=${this.$projectId}`)
          }
        }
      } else {
        MessageBox.alert(data.msg);
      }
    },
    async submit1() {
      const q4 = this.questionList[3].options.filter((v) => v.choose)
      const q5 = this.questionList[4].options.filter((v) => v.choose)
      // const q6 = this.questionList[5].options.filter((v) => v.choose)
      if (q4.length === 0 || q5.length === 0) {
        return MessageBox.alert("请先选择答案", "提示");
      }
      let data = await this.$httpdf.get(this.apiHost + `user/saveMobile`, {
        mobile: this.mobile,
        verCode: this.vcode
      })
      if (data.code === 0) {
        Vue.prototype.$mobile = this.mobile
        this.$util.cookie.set("mobile", this.$mobile, {
          expires: 60,
        });
        this.submitList.push({
          questionId: this.questionList[0].questionId,
          options: [{
            id: this.questionList[0].options[0].id,
            text: this.name
          }]
        })
        this.submitList.push({
          questionId: this.questionList[1].questionId,
          options: [{
            id: this.questionList[1].options[0].id,
            text: this.mobile
          }]
        })
        this.submitList.push({
          questionId: this.questionList[2].questionId,
          options: [{
            id: this.questionList[2].options[1].id,
            text: this.questionList[2].options[1].name,
          }]
        })
        this.submitList.push({
          questionId: this.questionList[3].questionId,
          options: q4.map(v => {
            return {
              id: v.id,
              text: v.name
            }
          })
        })
        this.submitList.push({
          questionId: this.questionList[4].questionId,
          options: q5.map(v => {
            return {
              id: v.id,
              text: v.name
            }
          })
        })
        // this.submitList.push({
        //   questionId: this.questionList[5].questionId,
        //   options: q6.map(v => {
        //     return {
        //       id: v.id,
        //       text: v.name
        //     }
        //   })
        // })
        data = await this.$httpdf.post( this.apiHost + 'jdQuestion/' + this.surveyId + '/submit', { answers: this.submitList })
        if (data.code === 0) {
          if (this.canGet) {
            let parm = new FormData();
            parm.append("name", this.$userInfo.nickName);
            data = await this.$httpdf.post( this.apiHost + 'jdQuestion/receive', parm)
            this.showRedPac = true
            if (data.code == 0) {
              this.redPacMoney = data.data
            } else {
              this.redPacMoney = 0
            }
          } else {
            this.$goPage(`coupon?proejctId=${this.$projectId}`)
          }
        }
      } else {
        MessageBox.alert(data.msg);
      }
    },
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight == windowFocusHeight) {
        return;
      }
      console.log(this.windowHeight + "--" + windowFocusHeight);
      console.log("修复");
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    },
    blurInput() {
      this.temporaryRepair();
    },
    //获取验证码
    async getVcode() {
      const TIME_COUNT = 60;
      if (!this.mobile) {
        return MessageBox.alert("请输入手机号", "提示");
      } else {
        //获取验证码
        let parm = new FormData();
        parm.append("mobile", this.mobile);
        const data = await this.$httpdf.post(this.apiHost + `common/smsCode`, parm)
        if (data.code == 0) {
          Toast({
            message: "验证码已发送至您的手机",
            duration: 2000,
          });
          if (!this.timers && this.mobile) {
            this.counts = TIME_COUNT;
            this.showVcode = true;
            this.timers = setInterval(() => {
              if (this.counts > 0 && this.counts <= TIME_COUNT) {
                this.counts--;
              } else {
                this.showVcode = false;
                clearInterval(this.timers);
                this.timers = null;
              }
            }, 1000);
          }
        } else {
          MessageBox.alert(data.msg);
        }
      }
    },
    //ip定位
    async getLocationByIp() {
      Vue.prototype.$infoId = undefined
      this.$util.cookie.remove('infoId')
      Indicator.open({
        text: "加载中...",
        spinnerType: "fading-circle",
      });
      let that = this;
      const data = await this.$httpdf.get(this.apiHost + 'user/getLocationByIp')
      Indicator.close();
      if (data.code == 0) {
        if (!data.data.curLocation) {
          //本地测试用====================================>>>>>
          // that.localCity = that.$root.curLocation.location;
          // that.isLocation = true;  //默认在区域内
          //<<<<<=============================================

          //如果没有curLocation，说明ip定位失败，调取gps定位
          await that.getLocationByGps();
        } else {
          Vue.prototype.$infoId = data.data.curLocation.infoId;
          this.$util.cookie.set("infoId", this.$infoId, {
            expires: 60,
          });
          console.log(
            `当前城市名称--->${data.data.curLocation.location}-----当前infoId--->${data.data.curLocation.infoId}`
          );
        }
      } else {
        MessageBox.alert(data.msg)
      }
    },
    //gps定位
    async getLocationByGps() {
      //  let res = { latitude: 30.585323333740234, longitude: 114.36740112304688 };
      let that = this;
      that.$wx.ready(() => {
        that.$wx.getLocation().then((res) => {
          Indicator.open({
            text: "加载中...",
            spinnerType: "fading-circle",
          });
          console.log("$wx.getLocation", res);
          // let url = `${that.$apidf.xc_voice_purchase.getLocationByGps}?latitude=${res.latitude}&longitude=${res.longitude}&fromOpenId=${that.$fopenid}&openId=${that.$openid}`;
          that.$httpdf
            .get(
              this.apiHost + 'user/getLocationByGps',
              {
                fromOpenId: this.$fopenid, //有就传，用于保存浏览记录
                openId: this.$openid,
                latitude: res.latitude,
                longitude: res.longitude,
              }
            )
            .then( async (data) => {
              Indicator.close();
              console.log("getLocationByGps---", data);
              if (data.code != 0) {
                that.$showModal("不在活动区域内");
              } else {
                console.log("GPS调取成功！");
                if (!data.data.curLocation) {
                  that.$showModal("不在活动区域内");
                  return;
                }
                Vue.prototype.$infoId = data.data.curLocation.infoId;
                this.$util.cookie.set("infoId", this.$infoId, {
                  expires: 60,
                });
                console.log(
                  `当前城市名称--->${data.data.curLocation.location}-----当前infoId--->${data.data.curLocation.infoId}`
                );
              }
            });
        });
      });
    },
    // 参与游戏
    async getParticipate () {
      const data = await this.$httpdf.post(this.apiHost + 'user/participate')
      if (data.code == 0) {
        Vue.prototype.$key = data.data.nonceStr
        this.$util.cookie.set("key", this.$key, {
          expires: 60,
        });
        if (data.data.mobile) {
          Vue.prototype.$mobile = data.data.mobile
          this.$util.cookie.set("mobile", this.$mobile, {
            expires: 60,
          });
        } else {
          Vue.prototype.$mobile = undefined
          this.$util.cookie.remove('mobile')
        }
      }else{
        if(this.timeStatus === 1){
          MessageBox.alert("活动未开始！");
        } else if (this.timeStatus === 3){
          MessageBox.alert("活动已结束！");
        } else {
          MessageBox.alert(data.msg);
        }
      }
    },
    async getQuestions () {
      const data = await this.$httpdf.get(this.apiHost + 'jdQuestion/' + this.surveyId + '/questions')
      if (data.code == 0) {
        this.questionList = data.data
      }
    },
    async getQrCode(){
      const data = await this.$httpdf.get(this.apiHost+`user/corpImg`, {
        salesOpenId: this.$salesOpenId,
        projectId: this.$projectId
      })
      if(data.code == 0){
        this.qrCode = Vue.prototype.$qrCode= data.data.corpImg;
        Vue.prototype.$salesOpenId = data.data.salesOpenId;
        this.$util.cookie.set("qrCode", this.$qrCode, {
          expires: 60,
        });
      }
      await this.initWxShare();
    },
    async initWxShare() {
      if (this.$userInfo) {
        let postObj = {
          channel: this.$channel,
          referenceOpenid: this.$fopenid
        };
        if (this.$userInfo.headImgUrl) {
          postObj.headImg = this.$userInfo.headImgUrl;
        }
        if (this.$userInfo.nickName) {
          postObj.nickname = this.$userInfo.nickName;
        }
        if (this.$userInfo.openId) {
          postObj.openid = this.$userInfo.openId;
        }
        if (this.$avoidWeChatBug == 1) {
          this.$avoidWeChatBug = 0
        } else {
          this.$avoidWeChatBug = 1
        }
        let shareTitle
        let shareContent
        let shareimg = 'share-icon'
        if (this.$projectId == '2597') {
          shareTitle = '金地江山风华'
          shareContent = '花一个车位钱得两个车位'
          shareimg = 'share-icon1'
        } else if (this.$projectId == '2604') {
          shareTitle = '新手盲选车位'
          shareContent = '标准位，随心停，省心选择'
          shareimg = 'share-icon2'
        }
        let url = "";
        const fpPromise = FingerprintJS.load()
        const fp = await fpPromise
        const result = await fp.get()
        await this.$httpdf.post(`/yq-auth/web/userAuth/saveUserVisitorId/${this.$userInfo.openId}/${result.visitorId}`)
        url = `${this.$site}#/answer?channel=${this.$channel}&fopenid=${this.$openid}&visitorId=${result.visitorId}&avoidWeChatBug=${this.$avoidWeChatBug}&projectId=${this.$projectId}&salesOpenId=${this.$salesOpenId}`;
        this.$wx.upShare(
          `${shareTitle || this.$config.shareTitle}`,
          shareContent || this.$config.shareContent,
          this.$rsh5.getRsShareUrl(url),
          `${this.$config.imgHost + shareimg}.jpg?v=${this.$config.OSSVersion}`
        );
      }
    },
  },
  async created() {
    const isSnapshotuser = this.$util.cookie.get('isSnapshotuser') || 0
    if (isSnapshotuser != 1) {
      await this.getLocationByIp(); //首先ip定位
      await this.getParticipate()
      await this.getQrCode()
      let data = await this.$httpdf.get(this.apiHost + 'jdQuestion/getSurvey')
      if (data.code == 0) {
        this.surveyId = data.data[0]
        this.getQuestions()
        data = await this.$httpdf.get(this.apiHost + `sample/${this.surveyId}/submitted`)
        if (data.code === 0) {
          if (data.data === 1) {
            MessageBox.alert("您已经答过题了", "提示").then(()=> {
              this.$goPage(`coupon?proejctId=${this.$projectId}`)
            })
          }
        }
      }
      data = await this.$httpdf.post( this.apiHost + 'jdQuestion/checkReceive')
      if (data.code == 0) {
        this.canGet = true
      }
    }
    if (this.$projectId == '2597') {
      document.title = '花一个车位钱得两个车位'
    } else if (this.$projectId == '2604') {
      document.title = '新手盲选车位'
    }
  },
  async mounted() {
  },
};
</script>
<style lang="scss" scoped>
.bg {
  padding-bottom: 200px;
  background: url( $imgHost + 'bg_bottom.png?v=' + $OSSVersion) 0 bottom / 100% no-repeat, url( $imgHost + 'coupon_bg.png?v=' + $OSSVersion) 0 0 / 100% no-repeat, #A32626;
  .answer-box {
    margin-top: 27px;
    width: 375px;
    height: 568px;
    background: url( $imgHost + 'answer_box1.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    padding: 94px 60px 0;
    position: relative;
    .icon {
      position: absolute;
      top: 135px;
      right: 6px;
      z-index: 1;
      width: 87px;
      height: 77px;
      background: url( $imgHost + 'answer_icon.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    }
    .asnwer_txt {
      margin-top: 15px;
      font-size: 16px;
      font-family: Songti SC;
      font-weight: bold;
      color: #000000;
      line-height: 18px;
    }
    .input_txt {
      width: 200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      margin: 15px 0 0 28px;
      .left {
        flex: 1;
        input {
          width : 100%;
        }
      }
      .right {
        width: 75px;
        height: 36px;
        background: #E4594B;
        border: 1px solid #411215;
        border-radius: 5px;
        font-size: 12px;
        font-family: Songti SC;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 18px;
        margin-left: 11px;
        @extend .flex-center-center;
      }
      input {
        // background: #fff;
        background: rgba($color: #fff, $alpha: 0.5);
        border: 1px solid #2D2D2D;
        border-radius: 5px;
        width: 100%;
        height: 36px;
        line-height: 36px;
        text-indent: 10px;
        font-size: 12px;
        font-family: Songti SC;
        font-weight: 500;
        color: #333;
        &::-webkit-input-placeholder{
          color: #999;
        }
      }
      .multiselect {
        min-height: auto;
      }
      ::v-deep .multiselect__tags {
        height: 36px !important;
        line-height: 36px !important;
        min-height: 36px !important;
        border: 0;
        padding-top: 0;
        padding-left: 10px;
        border: 1px solid #2D2D2D;
        border-radius: 5px;
        font-size: 12px;
        font-family: Songti SC;
        font-weight: 500;
        color: #333;
        .multiselect__input, .multiselect__single{
          background-color: transparent;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 0;
          margin: 0;
          line-height: 36px !important;
          font-size: 12px;
          font-family: Songti SC;
          font-weight: 500;
          color: #333;
        }
        .multiselect__placeholder {
          line-height: 36px !important;
          font-size: 12px;
          font-family: Songti SC;
          font-weight: 500;
          padding: 0;
          color: #999;
        }
      }
      ::v-deep .multiselect__select {
        height: 36px;
        &::before {
          color: #333;
          border-color: #333 transparent transparent;
        }
      }
      ::v-deep .multiselect__option {
        white-space: normal;
      }
    }
    .asnwer_radio {
      display: flex;
      margin-top: 10px;
      .radio {
        flex: 1;
        text-indent: 40px;
        font-size: 13px;
        font-family: Songti SC;
        font-weight: 400;
        color: #411215;
        line-height: 18px;
        position: relative;
        &::after {
          content: '';
          display: block;
          position: absolute;
          left: 20px;
          top: 50%;
          transform: translateY(-50%);
          width: 11px;
          height: 11px;
          border: 1px solid #411215;
          border-radius: 50%;
        }
        &.choose {
          &::after {
            background: #E4594B;
          }
        }
      }
    }
    .btn {
      margin: 18px auto 0;
      width: 206px;
      height: 44px;
      background: url( $imgHost + 'answer_btn2.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
      &.not {
        background: url( $imgHost + 'answer_btn1.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
      }
    }
  }
  .code-box {
    margin-top: 33px;
    width: 305px;
    height: 287px;
    background: url( $imgHost + 'code_box.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    padding: 28px 53px 0;
    img {
      width: 200px;
      border-radius: 5px;
    }
    .txt {
      margin: 12px auto 0;
      width: 134px;
      height: 26px;
      background: url( $imgHost + 'code_txt.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    }
  }
  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    background: rgba($color: #000000, $alpha: 0.6);
    .answer-box1 {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      width: 375px;
      height: 375px;
      background: url( $imgHost + 'answer_box2.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
      padding: 100px 0 0 62px;
      animation: showbox 500ms;
      .asnwer_txt {
        margin-top: 10px;
        font-size: 16px;
        font-family: Songti SC;
        font-weight: bold;
        color: #000000;
        line-height: 18px;
      }
      .asnwer_radio {
        display: flex;
        margin-top: 8px;
        flex-wrap: wrap;
        padding: 0 40px 0 10px;
        .radio {
          min-width: 50%;
          margin-bottom: 5px;
          text-indent: 20px;
          font-size: 14px;
          font-family: Songti SC;
          font-weight: 400;
          color: #411215;
          line-height: 18px;
          position: relative;
          &::after {
            content: '';
            display: block;
            position: absolute;
            left: 0px;
            top: 50%;
            transform: translateY(-50%);
            width: 11px;
            height: 11px;
            border: 1px solid #411215;
            border-radius: 50%;
          }
          &.choose {
            &::after {
              background: #E4594B;
            }
          }
        }
      }
      .btn-box {
        padding-right: 62px;
        .btn {
          margin: 15px auto 0;
          width: 206px;
          height: 44px;
          background: url( $imgHost + 'answer_btn2.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
          &.not {
            background: url( $imgHost + 'answer_btn1.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
          }
        }
      }
    }
    .redPac-box {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 300px;
      height: 415px;
      .box {
        width: 300px;
        height: 415px;
        background: url( $imgHost + 'redpac_bottom.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
        animation: showbox1 500ms;
      }
      .before {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        .top {
          position: absolute;
          top: 0;
          left: 0;
          width: 300px;
          height: 324px;
          background: url( $imgHost + 'redpac_top1.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
          &.ani {
            animation: openRedPac 1s linear forwards;
          }
          &.top1 {
            background: url( $imgHost + 'redpac_top2.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
          }
        }
        .btn {
          position: absolute;
          left: 50%;
          bottom: 53px;
          transform: translateX(-50%);
          width: 95px;
          height: 95px;
          background: url( $imgHost + 'redpac_btn1.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
          &.ani {
            animation: openRedPac1 1s linear;
          }
        }
      }
      .result {
        width: 100%;
        height: 100%;
        padding: 80px 0 0;
        text-align: center;
        .txt {
          font-size: 22px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #C1A468;
          line-height: 100%;
        }
        .txt1 {
          padding-top: 20px;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #C1A468;
          line-height: 40px;
        }
        .money {
          margin-top: 20px;
          font-size: 90px;
          font-family: DIN;
          font-weight: bold;
          color: #C1A468;
          span {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
          }
        }
        .tips {
          margin-top: 20px;
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
        }
        .btn {
          position: absolute;
          left: 50%;
          bottom: 67px;
          transform: translateX(-50%);
          width: 170px;
          height: 55px;
          background: url( $imgHost + 'redpac_btn2.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
          padding-bottom: 3px;
          font-size: 22px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #FCE6B4;
          @extend .flex-center-center;
        }
      }
    }
  }
}
@keyframes showbox {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes showbox1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes openRedPac {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-1000px);
  }
}
@keyframes openRedPac1 {
  0% {
    transform: rotateY(0) translateX(-50%);
    transform-origin: 0 50%;
  }
  100% {
    transform: rotateY(360deg) translateX(-50%);
    transform-origin: 0 50%;
  }
}
</style>